"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var NoPreview = function NoPreview(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: '0 0 45 41'
  }, props), /*#__PURE__*/_react["default"].createElement('g', {
    stroke: 'none',
    strokeWidth: '1',
    fill: 'none',
    fillRule: 'evenodd'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(-231.000000, -583.000000)',
    fill: 'currentColor',
    fillRule: 'nonzero'
  }, /*#__PURE__*/_react["default"].createElement('g', {
    transform: 'translate(231.000000, 583.000000)'
  }, /*#__PURE__*/_react["default"].createElement('path', {
    d: 'M36.4979998,12.659406 C39.8429078,15.00969 42.5882982,18.172676 44.4540984,21.866612 C40.3561538,29.979446 32.0172506,35.533306 22.3967627,35.533306 C19.701332,35.533306 17.1068136,35.097148 14.6776423,34.29117 L18.0360329,30.961806 C19.4602181,31.27357 20.9212115,31.433306 22.3967627,31.433306 C26.2550821,31.433306 30.0157153,30.344838 33.2722839,28.285572 C35.8640727,26.646556 38.0604843,24.45117 39.7101504,21.86653 C38.1139181,19.365284 36.0044399,17.230578 33.5216693,15.610012 L36.4979998,12.659406 Z M22.3967627,29.810362 C21.4178318,29.810362 20.4688437,29.683262 19.5651833,29.445872 L33.0573078,16.07036 C33.2970156,16.966046 33.4253892,17.906586 33.4253892,18.877056 C33.4253892,24.91529 28.4876402,29.810362 22.3967627,29.810362 Z M41.6968797,0 L39.3818549,0 L29.9207586,9.379242 C27.5479988,8.613772 25.0201486,8.2 22.39668,8.2 C12.7759439,8.2 4.43712339,13.75386 0.339344262,21.866694 C2.17710403,25.505116 4.8683162,28.62784 8.14531532,30.966562 L0.339426977,38.704902 L0.339344262,41 L2.65453447,41 L41.6968797,2.295016 L41.6968797,0 Z M18.2610174,13.410362 C20.3307925,13.410362 22.0454725,14.917686 22.3490362,16.885522 L17.6307298,21.56313 C15.6458202,21.262026 14.1253548,19.562248 14.1253548,17.510362 C14.1252721,15.246014 15.9768453,13.410362 18.2610174,13.410362 Z M5.08329223,21.866612 C6.73295831,19.281808 8.92928719,17.086586 11.5209933,15.447734 C11.6898144,15.34097 11.8602899,15.237568 12.0318406,15.13597 C11.6027984,16.303076 11.3680535,17.56276 11.3680535,18.877056 C11.3680535,21.376416 12.2146405,23.67955 13.6383295,25.52086 L11.1159384,28.02145 C8.70033234,26.413758 6.64619037,24.315542 5.08329223,21.866612 Z'
  })))));
};
/* eslint-enable */
var _default = NoPreview;
exports["default"] = _default;